export const inputFocusClass =
  "focus:outline-none! focus-visible:outline-none! focus:ring-2! focus:ring-inset! focus:ring-secondary! dark:focus:ring-secondary-dark! focus-visible:ring-2! focus-visible:ring-inset! focus-visible:ring-secondary! dark:focus-visible:ring-secondary-dark!"
